import { render, staticRenderFns } from "./InstantPrintJob.vue?vue&type=template&id=4a506de0&"
import script from "./InstantPrintJob.vue?vue&type=script&lang=js&"
export * from "./InstantPrintJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports